import { MaskedLines, Reveal } from "@/components/Motion";
import { CtaLink } from "@/components/CtaLink";

export const CtaBanner = ({ lines = ["Have an Idea?", "Let’s Bring It to Life."] }) => (
  <section className="on-dark grain relative overflow-hidden bg-royal text-white" aria-label="Start a project" data-testid="cta-banner">
    <div className="pointer-events-none absolute -right-32 -top-32 h-[28rem] w-[28rem] rounded-full border border-white/15" aria-hidden="true" />
    <div className="pointer-events-none absolute -right-10 top-24 h-[18rem] w-[18rem] rounded-full border border-lime/40" aria-hidden="true" />
    <div className="shell relative py-24 sm:py-36">
      <p className="eyebrow text-lime">Start a project</p>
      <MaskedLines
        as="h2"
        className="mt-6 font-display text-[2.6rem] font-extrabold leading-[1.02] tracking-[-0.045em] sm:text-6xl lg:text-8xl"
        lines={[{ content: lines[0] }, { content: lines[1] }]}
      />
      <Reveal delay={0.3} className="mt-12 flex flex-wrap items-center gap-6">
        <CtaLink to="/contact" variant="lime" testid="cta-banner-start-project-button">Start a Project</CtaLink>
        <p className="max-w-sm text-sm text-white/85">Tell us about your business and the design support you need.</p>
      </Reveal>
    </div>
  </section>
);
